import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

export const SentryInit = () => {
  if (!process.env.REACT_APP_SENTRY_VERSION) {
    return;
  }
  Sentry.init({
    dsn: 'https://3719cf4c5b524902a6dc5c1d210d6cc7@sentry.dsers.com/27',
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
};
